import axios from 'axios';

import { getEnv, getCsrfToken } from '@ctct/ctct-helpers';

const getBaseUrl = () => {
  if (getEnv() === 'local') {
    return 'https://localhost:9000/v1/settings';
  }

  return `https://app${getEnv()}constantcontact.com/v1/settings`;
};

const options = { credentials: 'include', headers: {} };
const token = getCsrfToken();

if (getEnv() !== 'local') {
  options.headers['X-CSRF-Token'] = token;
}

const APPLICATION_ID = 'myaccount';
const getFeatureSetting = async (settingName) =>
  (await axios.get(`${getBaseUrl()}/applications/${APPLICATION_ID}/accounts/features/${settingName}`, options)).data;

const getAccountSetting = async (settingName) =>
  (await axios.get(`${getBaseUrl()}/applications/${APPLICATION_ID}/accounts/settings/${settingName}`, options)).data;

const setAccountSetting = async (settingName, settingValue) =>
  (
    await axios.put(
      `${getBaseUrl()}/applications/${APPLICATION_ID}/accounts/settings/${settingName}`,
      settingValue,
      options
    )
  ).data;

export default {
  getFeatureSetting,
  getAccountSetting,
  setAccountSetting,
};
